// src/components/admin/user/UsersListPage.tsx

import { Helmet, HelmetProvider } from "react-helmet-async";
import AboutSection from "../../AboutSection";
import UserList from "./UserList";

const UsersListPage: React.FC = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <title>User Management</title>
          <meta name="description" content=" " />
          <meta name="keywords" content=" " />
          <meta property="og:title" content=" " />
          <meta property="og:description" content=" " />
          {/*
          <meta
            property="og:image"
            content="https://firojalamkhan.com/assets/immages/firoj.jpeg"
          />
          <meta property="og:url" content="https://firojalamkhan.com" />

          <script type="application/ld+json">
            {`
            {
              "@context": "http://schema.org",
              "@type": "Person",
              "name": "Firoj Alam Khan",
              "jobTitle": "Senior Software/Product Architect",
              "url": "https://firojalamkhan.com",
              "sameAs": [
                "https://www.linkedin.com/in/firojalamkhan/",
                "https://github.com/firojalamkhan"
              ]
            }
            `}
          </script>
          */}
        </Helmet>
      </HelmetProvider>

      <div className="min-h-screen bg-gray-100 flex flex-col p-2">
        <AboutSection title="Users Management" iconName="users" />
        <UserList />
      </div>
    </div>
  );
};

export default UsersListPage;